var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindloop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.635,
    height: 33.846,
    viewBox: "0 0 27.635 33.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21634",
    "data-name": "\\uADF8\\uB8F9 21634",
    transform: "translate(0.921 0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10185",
    "data-name": "\\uD328\\uC2A4 10185",
    d: "M233.258,168.518a3.462,3.462,0,0,1,4.235-4.129",
    transform: "translate(-223.642 -148.94)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10186",
    "data-name": "\\uD328\\uC2A4 10186",
    d: "M249.486,150.083l-.43,4.731a1.081,1.081,0,0,1-1.13.989c-1.411-.087-3.713-.683-3.313-3.688.006-.04.011-.077.02-.117a3.912,3.912,0,0,1,3.706-3.105A1.1,1.1,0,0,1,249.486,150.083Z",
    transform: "translate(-223.678 -148.891)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10187",
    "data-name": "\\uD328\\uC2A4 10187",
    d: "M248.438,159.958l-1.623,20.009a1.088,1.088,0,0,1-1.085,1h-16.9a1.081,1.081,0,0,1-.831-.385c-1.284-1.527-5.355-7.067,3.213-7.067,0,0,3.252,0,8.742.506a1.087,1.087,0,0,0,1.189-1.057c.062-2.942.71-10.646,5.63-14.016A1.085,1.085,0,0,1,248.438,159.958Z",
    transform: "translate(-223.619 -148.923)",
    fill: "none",
    stroke: "#adb5bd",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10188",
    "data-name": "\\uD328\\uC2A4 10188",
    d: "M223.63,166.527s-1-9.477,11.688-11.207",
    transform: "translate(-223.612 -148.912)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10189",
    "data-name": "\\uD328\\uC2A4 10189",
    d: "M227.895,168.025s-.748-7.107,8.766-8.406",
    transform: "translate(-223.625 -148.925)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindloop);
export default __webpack_public_path__ + "static/media/windloop.a3726396cd7ec306ac9729f31e4e2523.svg";
export { ForwardRef as ReactComponent };